export * from './vorlage-gespeichert.interface';
